module.exports = __webpack_public_path__ + "5039901cd45d99bd5029b433e7231ceb.png";